export enum SkillId {
  DISCOUNT = "discount",
  HSA = "hsa",
}
